if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        // Retrieve the form element itself
        const formElement = this.form;
        
        // Get the checkbox element
        const checkbox = document.getElementById('subscribeCheckbox');
        const axChargeCode = document.querySelector('._ax_charge_code')?.value || '';
        
        if (axChargeCode === 'WEB_BUNDLE') {
            // Get values from the input elements
            const bundleProperties = {
              _bundle_title: document.querySelector('._bundle_title')?.value || '',
              _bundle_slug: document.querySelector('._bundle_slug')?.value || '',
              _bundle_image: document.querySelector('._bundle_image')?.value || '',
              _bundle_price: document.querySelector('._bundle_price')?.value || '',
              _bundle_compare_price: document.querySelector('._bundle_compare_price')?.value || '',
              _bundle_final_price: document.querySelector('._bundle_final_price')?.value || '',
              _bundle_final_compare_price: document.querySelector('._bundle_final_compare_price')?.value || '',
              _bundle_item_count: document.querySelector('._bundle_item_count')?.value || '',
   
                
            };
        
            // Append each property to the formData object
            appendPropertiesToFormData(bundleProperties);
        }
        
        if (checkbox) {
            if (checkbox.checked) {
                handleCheckedSubscription();
            } else {
                handleUncheckedSubscription();
            }
        } else {
          handleUncheckedSubscription();
        }
        
        /**
         * Handles the logic when the subscription checkbox is checked.
         */
        function handleCheckedSubscription() {
            // Get values from the input fields
            const applyDiscount = document.querySelector('.apply_discount')?.value ||  false;
          
            const subscribeFrequency = document.querySelector('.js-subscribe-frequency')?.value || null;
            const subscribeUnit = document.querySelector('.js-subscribe-unit')?.value || null;
            const subscribeTitle = document.querySelector('.js-subscribe-title')?.value || null;
            const subscribeDiscountPct = document.querySelector('.js-subscribe-discount-pct')?.value || null;
            const subscribeOriginalPrice = document.querySelector('.js-subscribe-original-price')?.value || null;
            const subscribeUrl = document.querySelector('.js-subscribe-url')?.value || null;
        
            // Check for missing values
            if (!subscribeFrequency || !subscribeUnit || !subscribeDiscountPct || !subscribeOriginalPrice || !subscribeUrl) {
                console.warn('Some subscription input fields are missing.');
                return; // Exit the function if required fields are missing
            }
        
            // Create properties object
            const subscriptionProperties = {
                _ax_charge_code: "WEB_SUBSCRIBE",
                _shipping_interval_frequency: Number(subscribeFrequency),
                _shipping_interval_unit_type: subscribeUnit,
                _subscription_variant_title: subscribeTitle,
                _subscription_pct_off: Number(subscribeDiscountPct),
                _subscription_original_price: Number(subscribeOriginalPrice),
                _subscription_url: subscribeUrl,
                _cart_calculation: Number(subscribeDiscountPct),
                _apply_discount: applyDiscount
            };
        
            // Append properties to formData
            appendPropertiesToFormData(subscriptionProperties);
        }
        
        /**
         * Handles the logic when the subscription checkbox is unchecked.
         */
        function handleUncheckedSubscription() {
            // Get values from the input fields
            const subscribeDiscountPct = formElement.querySelector('.js-subscribe-discount-pct')?.value || null;
            const applyDiscount = formElement.querySelector('.apply_discount')?.value ||  false;
            const otmquantityInput = document.getElementById('otmquantity')?.value ||  false;
            let uncheckedSubscriptionProperties = {};
            if(otmquantityInput != false)
            {
              // Create properties object
              uncheckedSubscriptionProperties = {
                  _cart_calculation: subscribeDiscountPct,
                  _tube_product: true
              };             
            }
            else
            {
               // Create properties object
              uncheckedSubscriptionProperties = {
                  _cart_calculation: subscribeDiscountPct,
                  _apply_discount: applyDiscount
              }; 
            }
            
        
            // Append properties to formData
            appendPropertiesToFormData(uncheckedSubscriptionProperties);
        }
        
        /**
         * Appends properties to the global formData object.
         * @param {Object} properties - Key-value pairs to append to formData.
         */
        function appendPropertiesToFormData(properties) {
            for (const [key, value] of Object.entries(properties)) {
                formData.append(`properties[${key}]`, value);
            }
        }

        
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener('modalClosed',() => {
                  const freeProductElement = document.querySelector('.freeproduct');
                  if (freeProductElement) 
                  {
                    this.addFreeGiftIfEligible(response);
                  }
                  else
                  {
                    this.cart.renderContents(response);
                  }
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } 
            else 
            {
              const freeProductElement = document.querySelector('.freeproduct');
              if (freeProductElement) 
              {
                this.addFreeGiftIfEligible(response);
              }
              else
              {
                this.cart.renderContents(response);
              }
            }//else closed

            var json_data = {
              value: response.final_line_price / 100.0,
              quantity: response.quantity,
              product_id: response.id,
              product_name: response.title,
              product_type: response.product_type,
              product_vendor: response.vendor,
              variant_id: response.variant_id,
              variant_name: response.variant_title
            };
            this.spotifyATCEvent(json_data);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
      
      //this is for free gift
      addFreeGiftIfEligible(old_response) {
        console.log("addFreeGiftIfEligible call...");
        let gift_with_purchse = document.querySelector('#gift_with_purchse');
        const cartElement = document.querySelector('cart-drawer');
        const free_id = document.querySelector('.freeproduct').value;
        
        const formData2 = new FormData(gift_with_purchse);
        formData2.append(
          'sections',
          cartElement.getSectionsToRender().map((section) => section.id)
        );
        formData2.append('sections_url', window.location.pathname);
        cartElement.setActiveElement(document.activeElement);

        fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          const cartTotal = cart.total_price;
          let freekey = '';

          // Check if the gift is already in the cart
          const giftInCart = cart.items.filter(item => item.id == free_id);
          if(giftInCart.length>0)
          {
            freekey = giftInCart[0].id;
          }
          
          if (freekey=='' && cartTotal > 0) {

            const config2 = fetchConfig('javascript');
            config2.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete config2.headers['Content-Type'];
            
            config2.body = formData2;
            fetch(`${routes.cart_add_url}`, config2)
            .then((response) => response.json())
            .then((response) => {
              cartElement.renderContents(response);
            })
            .catch((error) => {
              console.error('Error adding to cart:', error);
            });
          }//if closed
          else{
            console.log("Free gift already exist..");
            cartElement.renderContents(old_response);
          }//else closed
          
        })
        .catch(error => {
         console.error('Error fetching cart:', error);
        });
          
      }//function closed

      //Spotify script
      spotifyATCEvent(data){
        (function(w, d){
          
          var id='spdt-capture', n='script';
          if (!d.getElementById(id)) {
            w.spdt =
              w.spdt ||
              function() {
                (w.spdt.q = w.spdt.q || []).push(arguments);
              };
            var e = d.createElement(n); e.id = id; e.async=1;
            e.src = 'https://pixel.byspotify.com/ping.min.js';
            var s = d.getElementsByTagName(n)[0];
            s.parentNode.insertBefore(e, s);
          }
          
          w.spdt('conf', { key: '9ec78a80b0e4427187d34686a07270aa' });
          w.spdt('addtocart', {
            value: data.value,  // Dynamically populate from session data
            currency: 'USD',  
            quantity: data.qty,  // Dynamically populate from session data
            product_id: data.product_id,  // Dynamically populate from session data
            product_name: data.product_title,  // Dynamically populate from session data
            product_type: data.type,  // Dynamically populate from session data
            product_vendor: data.vendor,  // Dynamically populate from session data
            variant_id: data.variant_id,  // Dynamically populate from session data
            variant_name: data.variant_title,  // Dynamically populate from session data
          });
        })(window, document);
        tatari.track('addtocart', {
          value: data.value,
          currency: 'USD',  
          quantity: data.qty,
          product_id: data.product_id,
          product_name: data.product_title,
          product_type: data.type,
          product_vendor: data.vendor,
          variant_id: data.variant_id,
          variant_name: data.variant_title
        });
      }//fn closed
    });
}//if closed